// 公共api
import { createAxios } from "@/utils/axios";

const fileReqeust = createAxios({
  timeout: 30000,
  withCredentials: true,
});

// 上传文件
export function uploadFile(file) {
  const formData = new FormData();
  formData.append("file", file.file);
  return fileReqeust.post("/common/file/1.0/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
